import { render, staticRenderFns } from "./PromotionActa.vue?vue&type=template&id=2d186afe&"
import script from "./PromotionActa.vue?vue&type=script&lang=js&"
export * from "./PromotionActa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports